import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isSynopticElementStaticCsvConfiguration(obj: any): CsvConfigJsonResult {
  let errors = [];
  let valid = true;

  if (typeof obj !== 'object' ||
    obj === null) {
    errors.push({code: 'invalidStatic', key: ''});
    valid = false;
  }
  if (obj.value === undefined) {
    errors.push({code: 'notExist', key: 'value'});
    valid = false;
  } else if (typeof obj.value !== 'string') {
    errors.push({code: 'notText', key: 'value'});
    valid = false;
  }

  return {result: valid, errors: errors};
}
